import { MODES } from "@/lib/modes";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function DiscoverPage() {
  return (
    <div className="min-h-screen pb-28 pt-6 px-4 max-w-md mx-auto">
      <h1 className="font-heading text-3xl font-bold">Discover</h1>
      <p className="text-slate-400 text-sm">Explore what Jixxeo AI can identify.</p>

      <div className="mt-5 grid grid-cols-2 gap-2">
        {MODES.map((m) => (
          <Link key={m.id} to="/scan" state={{ mode: m.id }} data-testid={`discover-mode-${m.id}`} className="jx-glass rounded-2xl p-4 active:scale-95 relative overflow-hidden">
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full blur-2xl opacity-30" style={{ background: m.color }} />
            <Sparkles size={20} style={{ color: m.color }} />
            <p className="mt-2 font-heading font-bold text-lg">{m.label}</p>
            <p className="text-[11px] text-slate-400">{m.desc}</p>
          </Link>
        ))}
      </div>

      <div className="mt-6 jx-glass rounded-3xl p-4">
        <p className="text-[11px] font-mono-data uppercase tracking-widest text-cyan-300">Coming soon</p>
        <p className="mt-1 text-sm text-slate-300">Reality Assistant · Outfit AI · Room Designer · Price Hunter · Sound ID · Treasure Map · Business Scanner · Memory Pins</p>
      </div>
    </div>
  );
}
